export default __webpack_public_path__ + "static/media/select.d8a92b34.svg";